"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeSlotStatus = exports.getTimeSlotStatusType = exports.getTimeSlotStatusLabel = void 0;
var TimeSlot_1 = require("../../Enums/TimeSlot");
var Messages_1 = require("../../Enums/Messages");
var getTimeSlotStatusLabel = function (timeSlot) {
    switch (timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.status) {
        case TimeSlot_1.TimeSlotStatus.suspended:
            return "Suspendue";
        case TimeSlot_1.TimeSlotStatus.unavailable:
            return "Annulée";
        default:
            return "À venir";
    }
};
exports.getTimeSlotStatusLabel = getTimeSlotStatusLabel;
var getTimeSlotStatusType = function (timeSlot) {
    switch (timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.status) {
        case TimeSlot_1.TimeSlotStatus.suspended:
            return Messages_1.MessageType.Warning;
        case TimeSlot_1.TimeSlotStatus.unavailable:
            return Messages_1.MessageType.Error;
        default:
            return Messages_1.MessageType.Neutral;
    }
};
exports.getTimeSlotStatusType = getTimeSlotStatusType;
var getTimeSlotStatus = function (timeSlot) {
    return { label: (0, exports.getTimeSlotStatusLabel)(timeSlot), type: (0, exports.getTimeSlotStatusType)(timeSlot) };
};
exports.getTimeSlotStatus = getTimeSlotStatus;
exports.default = { getTimeSlotStatus: exports.getTimeSlotStatus };
//# sourceMappingURL=TimeSlotStatus.js.map